export class AppURLs {
 // STAGENAME_URL
 static DASHBOARD_URL = '/dashboard';
 static REVIEW_EDIT_DATA_V1_URL = '/home/review/show-all';
}
